import React, { useEffect, useState } from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { nDecimal } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';

const intangibleTypes = [
  { code: 'N', name: 'Ninguno' },
  { code: '01', name: 'Intangible adquirido' },
  { code: '02', name: 'Intagieble en etapa de investigación' },
  { code: '03', name: 'En etapa de desarrollo' },
  { code: null, name: '-' }
];

export default function WriteTax(props) {
  const { inputChange, dataProduct } = props; //data Products

  // #region listados
  const [measures, setMeasures] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [exisTypes, setExisTypes] = useState([]);

  async function listMeasures() {
    let response = await wsGetAll('logi/measure-unit-type');
    if (response.success) setMeasures(response.data);
  }

  async function listCatalogs() {
    let response = await wsGetAll('logi/existence-catalog');
    if (response.success) setCatalogs(response.data);
  }

  async function listExistenceTypes() {
    let response = await wsGetAll('logi/existence-type');
    if (response.success) setExisTypes(response.data);
  }
  // #endregion

  useEffect(() => {
    listCatalogs();
    listMeasures();
    listExistenceTypes();
  }, []);

  return (
    <>
      <GridItem xs={12} lg={4} xl={4}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Gestión</h4>
          </CardHeader>
          <CardBody>
            <FormControl fullWidth margin="normal">
              <InputLabel>Artículo por serie</InputLabel>
              <Select
                value={dataProduct.ManSerNum || ''}
                inputProps={{
                  name: 'ManSerNum',
                  onChange: inputChange
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Artículo por lotes</InputLabel>
              <Select
                value={dataProduct.ManBtchNum || ''}
                inputProps={{
                  name: 'ManBtchNum',
                  onChange: inputChange
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Artículo de revaluación</InputLabel>
              <Select
                value={dataProduct.U_SYP_NOM_OR_REV || ''}
                inputProps={{
                  name: 'U_SYP_NOM_OR_REV',
                  onChange: inputChange
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
          </CardBody>
        </Card>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>SUNAT</h4>
          </CardHeader>
          <CardBody>
            <FormControl fullWidth margin="normal">
              <InputLabel>Unid. medida SUNAT</InputLabel>
              <Select
                value={dataProduct.U_SYP_TIPUNMED || ''}
                inputProps={{
                  name: 'U_SYP_TIPUNMED',
                  onChange: inputChange
                }}
              >
                {measures.map((item) => {
                  return (
                    <MenuItem key={item.Code} value={item.Code}>
                      {item.Name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Catálogo de existencia SUNAT</InputLabel>
              <Select
                value={dataProduct.logi_existence_catalog_id_sunat || ''}
                inputProps={{
                  name: 'logi_existence_catalog_id_sunat',
                  onChange: inputChange
                }}
              >
                {catalogs.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.Name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Catálogo de existencia</InputLabel>
              <Select
                value={dataProduct.logi_existence_catalog_id || ''}
                inputProps={{
                  name: 'logi_existence_catalog_id',
                  onChange: inputChange
                }}
              >
                {catalogs.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.Name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Servicio público</InputLabel>
              <Select
                value={dataProduct.U_SYP_SERVPUBLICO || ''}
                inputProps={{
                  name: 'U_SYP_SERVPUBLICO',
                  onChange: inputChange
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Requiere ICBPER</InputLabel>
              <Select
                value={dataProduct.U_SYP_ICBPER || ''}
                inputProps={{
                  name: 'U_SYP_ICBPER',
                  onChange: inputChange
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} lg={8} xl={8}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Impuestos</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={6}>
                <TextField
                  label="Cod. Detracción"
                  name="U_SYP_CODDET"
                  value="CIE-10"
                  margin="normal"
                  fullWidth
                  disabled
                />
                {/* <FormControl fullWidth margin="normal"> //se comento xq no se encontro sentido
                  <InputLabel>Impuesto acreedores</InputLabel>
                  <Select
                    value={dataProduct.TaxCodeAR || ''}
                    inputProps={{
                      name: 'TaxCodeAR',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl> */}
                <FormControl fullWidth margin="normal">
                  <InputLabel>Retención de impuestos</InputLabel>
                  <Select
                    value={dataProduct.WTLiable || ''}
                    inputProps={{
                      name: 'WTLiable',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} lg={6} xl={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Sujeto a impuestos</InputLabel>
                  <Select
                    value={dataProduct.VATLiable || ''}
                    inputProps={{
                      name: 'VATLiable',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Impuesto indirecto</InputLabel>
                  <Select
                    value={dataProduct.IndirctTax || ''}
                    inputProps={{
                      name: 'IndirctTax',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Cuenta de aspectos diferidos</InputLabel>
                  <Select
                    value={dataProduct.U_SYP_CTAVTAD || ''}
                    inputProps={{
                      name: 'U_SYP_CTAVTAD',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Otros</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Tipo de existencia</InputLabel>
                  <Select
                    value={dataProduct.U_SYP_TIPEXIST || ''}
                    inputProps={{
                      name: 'U_SYP_TIPEXIST',
                      onChange: inputChange
                    }}
                  >
                    {exisTypes.map((item) => {
                      return (
                        <MenuItem key={item.Code} value={item.Code}>
                          {item.Name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Tipo intangible</InputLabel>
                  <Select
                    value={dataProduct.U_SYP_TIPOINTANGIBLE || ''}
                    inputProps={{
                      name: 'U_SYP_TIPOINTANGIBLE',
                      onChange: inputChange
                    }}
                  >
                    {intangibleTypes.map((item) => {
                      return (
                        <MenuItem key={item.code} value={item.code}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <TextField
                  label="Descripción Naciones Unidas"
                  name="U_SYP_UNSPSCDES"
                  value={dataProduct.U_SYP_UNSPSCDES || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
                <TextField
                  label="Descripción CUBSO"
                  name="U_SYP_CUBSODES"
                  value={dataProduct.U_SYP_CUBSODES || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
                <TextField
                  label="Nombre de padre"
                  name="U_SYP_NOM_PADRE"
                  value={dataProduct.U_SYP_NOM_PADRE || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={6}>
                <TextField
                  label="Tope de percepción"
                  name="U_SYP_TOPE"
                  value={nDecimal(dataProduct.U_SYP_TOPE) || ''}
                  inputProps={{ onChange: inputChange }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
                <FormControl fullWidth margin="normal">
                  <InputLabel>Afecto a percepción</InputLabel>
                  <Select
                    value={dataProduct.U_SYP_APER || ''}
                    inputProps={{
                      name: 'U_SYP_APER',
                      onChange: inputChange
                    }}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Cód. Naciones Unidas"
                  name="U_SYP_UNSPSC"
                  value={dataProduct.U_SYP_UNSPSC || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
                <TextField
                  label="Cód. CUBSO"
                  name="U_SYP_CUBSO"
                  value={dataProduct.U_SYP_CUBSO || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
                <TextField
                  label="Cód. de padre"
                  name="U_SYP_COMP_PADRE"
                  value={dataProduct.U_SYP_COMP_PADRE || ''}
                  inputProps={{ onChange: inputChange }}
                  margin="normal"
                  fullWidth
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
